<div class="backpage">
  <div class="flex flex-space-between align-items-center">
    <h2 class="page-header mat-headline">
      {{ implementationName }}
      {{ "APICreds.Details" | translate }}
    </h2>
  </div>
  <hr />
  <div class="flex details-page-container">
    <div class="info-box-container flex flex-column">
      <div class="card mat-elevation-z8">
        <div class="icon-container">
          <mat-icon>info</mat-icon>
        </div>
        <div class="card-header">
          <h3 class="mat-headline title">Total Active Licenses</h3>
        </div>
        <div class="total-active-creds-value">
          <h3 class="mat-headline">{{ totalActiveLicenses }}</h3>
        </div>
      </div>
      <div class="card mat-elevation-z8">
        <div class="icon-container">
          <mat-icon>style_outline</mat-icon>
        </div>
        <div class="card-header">
          <h3 class="mat-headline title">
            New Licenses {{ today | date: "MMMM, yyyy" }}
          </h3>
        </div>
        <div class="billing-date-value">
          <h3 class="mat-headline">{{ totalNewLicensesThisMonth }}</h3>
        </div>
      </div>
    </div>
    <div class="chart-section-container mat-elevation-z8">
      <div class="chart-container">
        <canvas id="CPChart"></canvas>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>
